import { useEffect, useRef } from 'react';

interface WordPPTViewerProps {
  fileUrl: string;
  sx?: any;
  onViewedFor10Seconds?: () => void;
}

export default function WordPPTViewer({ fileUrl, onViewedFor10Seconds }: WordPPTViewerProps) {
  // Store callback in ref to avoid re-running timer effect when callback changes
  const callbackRef = useRef(onViewedFor10Seconds);

  // Update ref when callback changes
  useEffect(() => {
    callbackRef.current = onViewedFor10Seconds;
  }, [onViewedFor10Seconds]);

  // 10-second viewing timer - runs once on mount
  useEffect(() => {
    if (!callbackRef.current) return;

    const timer = setTimeout(() => {
      console.log('Word/PPT content viewed for 10 seconds');
      callbackRef.current?.();
    }, 10000);

    return () => clearTimeout(timer);
  }, []); // Empty dependency array - timer only runs once on mount

  return (
    <iframe
      title="Office Document Viewer"
      src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`}
      height="1150px"
      style={{
        width: '100%',
        border: 'none',
      }}
    ></iframe>
  );
}
